import { useSyncStore } from '../../store/syncStore.js';
import { IcoWarning, IcoArrowUp } from './Icons.jsx';

export default function SyncBadge() {
  const isOnline     = useSyncStore((s) => s.isOnline);
  const pendingCount = useSyncStore((s) => s.pendingCount);
  const errorCount   = useSyncStore((s) => s.errorCount);

  if (!isOnline) {
    return (
      <span className="badge badge--offline">
        ● Offline{pendingCount > 0 ? ` · ${pendingCount} pendientes` : ''}
      </span>
    );
  }

  if (errorCount > 0) {
    return (
      <span className="badge badge--error">
        <IcoWarning size={12} /> {errorCount} error{errorCount > 1 ? 'es' : ''}
      </span>
    );
  }

  if (pendingCount > 0) {
    return (
      <span className="badge badge--pending">
        <IcoArrowUp size={11} /> Sincronizando…
      </span>
    );
  }

  return <span className="badge badge--online">● Online</span>;
}
